import {
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { SendCaseCommands } from "../../api/api";

type CaseCommandResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
  caseId?: string;
};

type caseCommandsInput = {
  caseIds: string[];
  commands: Object;
  filter?: Object;
};

export const useCaseCommands = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: async ({
      caseIds,
      filter,
      commands,
      token,
    }: caseCommandsInput & {
      token: string;
    }): Promise<CaseCommandResult> => {
      console.log('useCaseCommands - Sending data to API:', {
        caseIds,
        filter,
        commands,
        token: token ? 'present' : 'missing'
      });
      console.log('useCaseCommands - Commands data:', JSON.stringify(commands, null, 2));
      
      const response = await SendCaseCommands({
        authToken: token,
        body: {
          caseIds,
          filter,
          commands,
        },
      });
      return response;
    },

    onSuccess: (data) => {
      console.log("Case command result:", data);
    },

    onError: (error) => {
      console.error(
        "Error performing case operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      {
        caseIds,
        filter,
        commands,
      }: caseCommandsInput,
      options?: {
        onSuccess?: (data: CaseCommandResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutateAsync(
        {
          caseIds,
          filter,
          commands,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return {
    ...mutation,
    mutate: mutateWithToken,
  };
};
